<template>
  <section
    id="add-bloodinstrument-test"
    class="case-creation"
    v-loading="loading"
  >
    <div class="container-small-table">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">
                {{ `${getActionName} Test` }}
              </h3>
            </div>
            <div
              class="edit-block"
              v-if="!editForm && showEditConfigInformation"
            >
              <el-button class="edit-btn" @click="configFormView">
                <span class="edit-icon">
                  <img
                    src="@/assets/images/icons/edit-case-information.svg"
                    alt=""
                  />
                  <p>EDIT</p>
                </span>
              </el-button>
            </div>
          </div>

          <div class="case-creation__body pb-0">
            <div class="vue-form" v-if="editForm && !loading">
              <el-form :model="otherTestConfig" :rules="rules" ref="ruleForm">
                <el-row :gutter="30">
                  <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"
                          >Test Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          v-model="otherTestConfig.name"
                          placeholder="Enter Test Name"
                        ></el-input>
                        <p class="err" v-if="this.getErrors.name">
                          <FormError errorName="name"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"
                          >Case Type
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Casetype"
                          v-model="otherTestConfig.case_type_code"
                        >
                          <el-option
                            v-for="caseType in caseTypes"
                            :key="caseType.value"
                            :value="caseType.value"
                            :label="caseType.name"
                          ></el-option>
                        </el-select>
                        <p class="err" v-if="this.getErrors.case_type">
                          <FormError errorName="case_type"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"
                          >Category
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Category"
                          v-model="otherTestConfig.category_code"
                        >
                          <el-option
                            v-for="caseType in categoryList"
                            :key="caseType.value"
                            :value="caseType.value"
                            :label="caseType.name"
                          ></el-option>
                        </el-select>
                        <p class="err" v-if="this.getErrors.category_code">
                          <FormError errorName="category_code"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                    <div class="case-creation__input">
                      <el-form-item class="mb-0">
                        <label for="text"
                          >Status
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select Status"
                          v-model="otherTestConfig.status"
                        >
                          <el-option
                            v-for="status in statusList"
                            :key="status.value"
                            :value="status.value"
                            :label="status.name"
                          ></el-option>
                        </el-select>
                        <p class="err" v-if="this.getErrors.status">
                          <FormError errorName="status"></FormError>
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <p class="err" v-if="getErrors && getErrors.critical_error">
                    <FormError errorName="critical_error"></FormError>
                  </p>
                </el-row>
              </el-form>
              <div class="case-creation__actions" v-if="editForm && !loading">
                <ul class="list">
                  <li>
                    <el-button
                      type="default"
                      class="btn cancel-button"
                      @click="cancelCreation"
                      >Cancel</el-button
                    >
                  </li>
                  <li>
                    <el-button
                      type="success"
                      class="btn save-button"
                      @click="createTestConfig()"
                      :disabled="!isTestNameValid"
                      :loading="loadingProfile"
                    >
                      Save
                    </el-button>
                  </li>
                </ul>
              </div>
            </div>
            <div class="case-view-information" v-else-if="getClinicTestData">
              <el-row :gutter="30">
                <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Test Name</h4>
                    <p class="value">{{ getClinicTestData.name }}</p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Status</h4>
                    <p class="value">{{ getClinicTestData.status }}</p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Case Type</h4>
                    <p class="value">{{ getClinicTestData.case_type }}</p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="12" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Category</h4>
                    <p class="value">{{ getClinicTestData.category }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateBloodTestConfig"
    ></ResonForChange>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import { defineAsyncComponent } from "vue";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import bloodConstants from "@/config/constants/bloodConstants";

const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {
    ResonForChange,
    FormError,
  },
  name: "profile",
  computed: {
    ...mapGetters("bloodOtherTests", [
      "getTestCreationStatus",
      "getSingleTestData",
      "getTestUpdateStatus",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    getClinicTestData() {
      if (
        this.getSingleTestData &&
        Object.keys(this.getSingleTestData).length > 0 &&
        this.getSingleTestData
      ) {
        return this.getSingleTestData;
      }
      return null;
    },
    getActionName() {
      if (this.$route.name == "AddClinicalChemistryConfig") {
        return "Add";
      } else if (this.editForm) {
        return "Edit";
      } else {
        return "View";
      }
    },
    isTestNameValid() {
      return (
        this.otherTestConfig.name && this.otherTestConfig.name.trim().length > 0
      );
    },
  },

  data() {
    return {
      statusList: [
        {
          name: "Active",
          value: "ACTIVE",
        },
        // {
        //   name: "In Active",
        //   value: "INACTIVE",
        // },
      ],
      caseTypes: [
        {
          name: "Clinical Chemistry",
          value: "CLINICAL_CHEMISTRY",
        },
      ],
      categoryList: [
        {
          name: "Other Tests",
          value: "OTHER_TESTS",
        },
      ],
      loading: false,
      loadingProfile: false,
      showEditConfigInformation: false,
      otherTestConfig: {
        name: "",
        status: "ACTIVE",
        is_manually_added_test: true,
        case_type: "",
        case_type_code: "CLINICAL_CHEMISTRY",
        category_code: "OTHER_TESTS",
        category: "",
      },
      editForm: false,
      takeReasonDialog: false,
      test_id: "",
    };
  },
  created() {},
  async mounted() {
    this.$store.commit("errors/clear", null, { root: true });
    this.test_id = this.$route.params.test_id;
    if (this.$route.params.test_id) {
      this.editForm = false;
      this.showEditConfigInformation = true;
      this.getTestData();
    } else {
      this.editForm = true;
      this.showEditConfigInformation = false;
    }
  },
  methods: {
    configFormView() {
      this.editForm = true;
      this.setTestData();
      this.showEditConfigInformation = false;
    },
    setTestData() {
      if (this.getSingleTestData) {
        this.otherTestConfig = this.getSingleTestData;
      }
    },
    async getTestData() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "bloodOtherTests/fetchSingleTest",
          this.test_id
        );
        this.setTestData();
        this.showEditConfigInformation = true;
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    prepareParams() {
      let params = {
        ...this.otherTestConfig,
      };
      const selectedCaseType = this.caseTypes.find(
        (caseType) => caseType.value === this.otherTestConfig.case_type_code
      );

      params.case_type = selectedCaseType ? selectedCaseType.name : "";
      const selectedCategory = this.categoryList.find(
        (item) => item.value === this.otherTestConfig.category_code
      );
      params.category = selectedCategory ? selectedCategory.name : "";
      return params;
    },
    createTestConfig() {
      let params = this.prepareParams();
      params.test_id = this.$route.params.test_id;
      if (params.test_id) {
        this.updateBloodTestData();
        // this.askReason();
      } else {
        this.addTest(params);
      }
    },
    async addTest(params) {
      this.loadingProfile = true;
      await this.$store.dispatch("bloodOtherTests/createBloodTest", params);
      this.loadingProfile = false;
      if (this.getTestCreationStatus) {
        successNotification("Blood Test Config Created Successfully");
        this.goToAllTests();
      } else if (!this.getErrors) {
        errorNotification(this.getError || "Error in adding Blood Test Config");
      }
    },
    async updateBloodTestData() {
      try {
        this.loadingProfile = true;
        let params = this.prepareParams();
        params.id = this.$route.params.test_id;

        await this.$store.dispatch("bloodOtherTests/updateBloodTest", params);
        this.loadingProfile = false;
        if (this.getTestUpdateStatus) {
          successNotification("Blood Config Updated Successfully");
          this.goToAllTests();
        } else if (!this.getErrors) {
          errorNotification(
            this.getError || "Error in updating Blood Test Config"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    cancelCreation() {
      if (this.$route.params.test_id) {
        this.editForm = false;
        this.showEditConfigInformation = true;
      } else {
        if (this.$route.query.redirectRoute) {
          this.$router.push({
            name: this.$route.query.redirectRoute,
            query: { ...this.$route.query },
          });
        } else {
          this.goToAllTests();
        }
      }
    },
    goToAllTests() {
      this.$router.push({
        name: "ClinicalChemistryConfig",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>

<style lang="scss">
#add-bloodinstrument-test {
  .case-creation__heading .title-with-icon {
    width: 100%;
    max-width: 315px;
  }
  .edit-block {
    .edit-btn {
      border: none;
      padding: 0;
      min-height: 30px;
      .edit-icon {
        display: flex;
        align-items: center;
        margin-right: 10px;
        color: #111111;

        img {
          margin-right: 6px;
          width: 18px;
          margin-bottom: 3px;
          height: 18px;
        }
      }
      &:hover {
        background-color: transparent !important;
        color: #111111;
      }
    }
  }
}
</style>
